/**
 * @file: MwInfoPublish.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: MwInfoPublishController
 */
import request from '@/utils/request'

/**
 * 马尾-信息发布-删除（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mwInfopublishDelete(data) {
  return request({
    type: 'biz',
    url: 'mw/infopublish/delete',
    method: 'post',
    data
  })
}

/**
 * 马尾-信息发布-根据ID获取（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mwInfopublishGet(data) {
  return request({
    type: 'biz',
    url: 'mw/infopublish/get',
    method: 'post',
    data
  })
}

/**
 * 马尾-信息发布-新增（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mwInfopublishInsert(data) {
  return request({
    type: 'biz',
    url: 'mw/infopublish/insert',
    method: 'post',
    data
  })
}

/**
 * 马尾-信息发布-市监局食品检查趋势图（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mwInfopublishManageTrendMap(data) {
  return request({
    type: 'biz',
    url: 'mw/infopublish/manage/trend/map',
    method: 'post',
    data
  })
}

/**
 * 马尾-信息发布-分页（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mwInfopublishPageListGet(data) {
  return request({
    type: 'biz',
    url: 'mw/infopublish/page/list/get',
    method: 'post',
    data
  })
}

/**
 * 马尾-信息发布-更新状态（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mwInfopublishStatusUpdate(data) {
  return request({
    type: 'biz',
    url: 'mw/infopublish/status/update',
    method: 'post',
    data
  })
}

/**
 * 马尾-信息发布-本月街道食品检查百分比图（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mwInfopublishStreetMonthPercentMap(data) {
  return request({
    type: 'biz',
    url: 'mw/infopublish/street/month/percent/map',
    method: 'post',
    data
  })
}

/**
 * 马尾-信息发布-本月街道食品检查占比图（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mwInfopublishStreetMonthRatioMap(data) {
  return request({
    type: 'biz',
    url: 'mw/infopublish/street/month/ratio/map',
    method: 'post',
    data
  })
}

/**
 * 马尾-信息发布-街道食品检查趋势图（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mwInfopublishStreetTrendMap(data) {
  return request({
    type: 'biz',
    url: 'mw/infopublish/street/trend/map',
    method: 'post',
    data
  })
}

/**
 * 马尾-信息发布-更新（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mwInfopublishUpdate(data) {
  return request({
    type: 'biz',
    url: 'mw/infopublish/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/MwInfoPublish.js